var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "comp-clip_container",
      attrs: { onselectstart: "return false" }
    },
    [
      _c(
        "div",
        { staticClass: "comp-clip-img-list" },
        [
          _c(
            "label",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.fileList.length < _vm.maxLength,
                  expression: "fileList.length < maxLength"
                }
              ],
              staticClass: "comp-clip-img-item"
            },
            [
              _c("input", {
                staticClass: "file-btn",
                attrs: {
                  type: "file",
                  multiple: _vm.multiple,
                  disabled: _vm.spinning || _vm.disabled,
                  accept: _vm.accept
                },
                on: { change: _vm.changeFile }
              }),
              _c(
                "a-spin",
                { attrs: { spinning: _vm.spinning } },
                [
                  _vm._t("default", [
                    _c(
                      "div",
                      { staticClass: "checked-hit-view" },
                      [
                        _c("a-icon", { attrs: { type: "plus" } }),
                        _vm.tips
                          ? _c("span", [_vm._v(" " + _vm._s(_vm.tips) + " ")])
                          : _vm.imgW
                          ? _c(
                              "div",
                              { staticClass: "checked-hit-view-text" },
                              [
                                _c("p", [_vm._v(_vm._s(_vm.text))]),
                                !_vm.isStrictRestrictions && _vm.isClip
                                  ? [
                                      _vm.imgH
                                        ? _c("p", [
                                            _vm._v(
                                              " 上传(" +
                                                _vm._s(_vm.imgW * 1) +
                                                "px*" +
                                                _vm._s(_vm.imgH * 1) +
                                                "px)等比例的图片 "
                                            )
                                          ])
                                        : _c("p", [
                                            _vm._v(
                                              "(宽度最小" +
                                                _vm._s(_vm.imgW) +
                                                "px*高度自适应)"
                                            )
                                          ])
                                    ]
                                  : _vm._e(),
                                !_vm.isClip && !_vm.isStrictRestrictions
                                  ? [
                                      _vm.imgH && _vm.imgW
                                        ? _c("p", [
                                            _vm._v(
                                              " 建议上传(" +
                                                _vm._s(_vm.imgW) +
                                                "px*" +
                                                _vm._s(_vm.imgH) +
                                                "px)的图片 "
                                            )
                                          ])
                                        : _vm.imgW
                                        ? _c("p", [
                                            _vm._v(
                                              "建议上传宽度(" +
                                                _vm._s(_vm.imgW) +
                                                "px的图片)"
                                            )
                                          ])
                                        : _vm.imgH
                                        ? _c("p", [
                                            _vm._v(
                                              "建议上传高度(" +
                                                _vm._s(_vm.imgH) +
                                                "px的图片)"
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  : _vm.isStrictRestrictions &&
                                    _vm.imgW &&
                                    _vm.imgH
                                  ? [
                                      _vm.imgH
                                        ? _c("p", [
                                            _vm._v(
                                              "严格上传(" +
                                                _vm._s(_vm.imgW) +
                                                "px*" +
                                                _vm._s(_vm.imgH) +
                                                "px)的图片"
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          : _c("div", [_vm._v("上传任意尺寸的图片，请慎重。")])
                      ],
                      1
                    )
                  ])
                ],
                2
              )
            ],
            1
          ),
          _c(
            "vue-draggable",
            {
              staticClass: "draggable-list",
              attrs: { disabled: _vm.isDrag || _vm.spinning },
              on: {
                update: function($event) {
                  return _vm.$emit("draggableUpdate")
                }
              },
              model: {
                value: _vm.fileList,
                callback: function($$v) {
                  _vm.fileList = $$v
                },
                expression: "fileList"
              }
            },
            _vm._l(_vm.fileList.slice(0, _vm.maxLength), function(item, i) {
              return _c(
                "div",
                {
                  key: item.url + i + "",
                  staticClass: "img-box comp-clip-img-item"
                },
                [
                  _c(
                    "div",
                    { staticClass: "img-cover" },
                    [
                      _c("a-icon", {
                        staticStyle: { "margin-right": "10px" },
                        attrs: { type: "eye" },
                        on: {
                          click: function($event) {
                            return _vm.handleImgView(i)
                          }
                        }
                      }),
                      _c(
                        "a-popconfirm",
                        {
                          attrs: {
                            title: "确认删除？",
                            "ok-text": "是",
                            "cancel-text": "否"
                          },
                          on: {
                            confirm: function($event) {
                              return _vm.handleImgDel(i)
                            }
                          }
                        },
                        [_c("a-icon", { attrs: { type: "rest" } })],
                        1
                      )
                    ],
                    1
                  ),
                  _c("img", {
                    staticClass: "img-element",
                    attrs: { src: item.url, alt: "" }
                  })
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _c(
        "a-modal",
        {
          staticClass: "clip-dialog",
          attrs: {
            visible: _vm.showClipPopup,
            onselectstart: "return false",
            top: "5vh",
            "get-container": function() {
              return _vm.$el
            },
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showClipPopup = $event
            },
            opened: _vm.handleOpen
          }
        },
        [
          _vm._t(
            "title",
            [
              _c("div", { staticClass: "clip-header" }, [
                _c("div", { staticClass: "el-dialog__title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        !_vm.setMosaicIng
                          ? _vm.title || "图片裁剪"
                          : "添加马赛克"
                      ) +
                      " "
                  )
                ]),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.setMosaicIng && _vm.isNeedMosaic,
                        expression: "!setMosaicIng && isNeedMosaic"
                      }
                    ],
                    staticClass: "add-mosaic-btn",
                    attrs: { size: "small" },
                    on: { click: _vm.handleMosaicInit }
                  },
                  [_vm._v(" 添加马赛克 ")]
                ),
                _vm.showReset && !_vm.setMosaicIng
                  ? _c(
                      "div",
                      {
                        staticClass: "control-reset",
                        on: { click: _vm.handleOpenFile }
                      },
                      [_vm._v(" 重新上传 ")]
                    )
                  : _vm._e()
              ])
            ],
            { slot: "title" }
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.setMosaicIng,
                  expression: "!setMosaicIng"
                }
              ],
              staticClass: "clip-box_content",
              attrs: { ondragstart: "return false" }
            },
            [
              _c("div", { staticClass: "clip-box_content-img" }, [
                _c("img", {
                  staticClass: "clip-img",
                  staticStyle: { "max-width": "100%", "max-height": "100%" },
                  attrs: { src: _vm.imgStr }
                })
              ]),
              _c(
                "div",
                {
                  staticClass: "clip-content-wrap",
                  style: { opacity: _vm.showCover ? 1 : 0 }
                },
                [
                  _c("div", { staticClass: "shade_lef shade_pop" }),
                  _c("div", { staticClass: "shade_right shade_pop" }),
                  _c("div", { staticClass: "shade_top shade_pop" }),
                  _c("div", { staticClass: "shade_bottom shade_pop" }),
                  _c(
                    "div",
                    {
                      staticClass: "center",
                      style: {
                        width: _vm.getCoverStyle.W + "px",
                        height: _vm.getCoverStyle.H + "px",
                        left: _vm.getCoverStyle.X + "px",
                        top: _vm.getCoverStyle.Y + "px"
                      }
                    },
                    [
                      _c("div", { staticClass: "center_box" }, [
                        !_vm.fixedSize
                          ? _c("div", { staticClass: "center_control" })
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              )
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.setMosaicIng,
                  expression: "setMosaicIng"
                }
              ],
              staticClass: "mosaic-box"
            },
            [
              _c(
                "ul",
                { staticClass: "mosaic-icon-list" },
                [
                  _vm._l(Object.keys(_vm.mosaicIcon), function(item, i) {
                    return _c(
                      "li",
                      {
                        key: i,
                        staticClass: "mosaic-icon-item",
                        class: {
                          current:
                            _vm.currentMosaic.id &&
                            _vm.currentMosaic.id === _vm.mosaicIcon[item].id
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            id: _vm.mosaicIcon[item].id,
                            src: _vm.mosaicIcon[item].url,
                            alt: _vm.mosaicIcon[item].name,
                            title: _vm.mosaicIcon[item].name
                          },
                          on: {
                            click: function($event) {
                              _vm.currentMosaic = _vm.mosaicIcon[item]
                            }
                          }
                        })
                      ]
                    )
                  }),
                  _c("li", {
                    class: [
                      "mosaic-icon-item",
                      "mosaicicon",
                      "icon-chexiao",
                      "control-log"
                    ],
                    style: {
                      color: _vm.allMosaicList.length ? "#000" : "#ccc"
                    },
                    on: { click: _vm.handleDelMosaic }
                  }),
                  _c("li", {
                    class: [
                      "mosaic-icon-item",
                      "mosaicicon",
                      "icon-chongzuo",
                      "control-log"
                    ],
                    style: {
                      color: _vm.recoverMosaicList.length ? "#000" : "#ccc"
                    },
                    on: { click: _vm.recoverMosaicLog }
                  })
                ],
                2
              ),
              _c("div", { staticClass: "mosaic-canvas-box" })
            ]
          ),
          _c(
            "div",
            {
              staticClass: "clip-control",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.DrawAndDown } },
                [_vm._v(" 确 定 ")]
              ),
              _c(
                "a-button",
                {
                  on: {
                    click: function($event) {
                      _vm.setMosaicIng
                        ? (_vm.setMosaicIng = false)
                        : (_vm.showClipPopup = false)
                    }
                  }
                },
                [_vm._v(" 取消 ")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.viewImageIng,
            expression: "viewImageIng"
          }
        ],
        staticClass: "show-img-origin-list-cover",
        on: {
          click: function($event) {
            _vm.viewImageIng = false
          }
        }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.viewImageIng,
              expression: "viewImageIng"
            }
          ],
          staticClass: "show-img-origin-box"
        },
        [
          _c("div", { staticClass: "show-img-origin-box-content" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.fileList.slice(0, _vm.maxLength).length > 1,
                    expression: "fileList.slice(0, maxLength).length > 1"
                  }
                ],
                staticClass: "control-toggle-left",
                on: {
                  click: function($event) {
                    return _vm.handleViewIndex(-1)
                  }
                }
              },
              [_c("a-icon", { attrs: { type: "left" } })],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.fileList.slice(0, _vm.maxLength).length > 1,
                    expression: "fileList.slice(0, maxLength).length > 1"
                  }
                ],
                staticClass: "control-toggle-right",
                on: {
                  click: function($event) {
                    return _vm.handleViewIndex(1)
                  }
                }
              },
              [_c("a-icon", { attrs: { type: "right" } })],
              1
            ),
            _c(
              "div",
              {
                staticClass: "close-img-origin-list",
                on: {
                  click: function($event) {
                    _vm.viewImageIng = false
                  }
                }
              },
              [_c("a-icon", { attrs: { type: "close" } })],
              1
            ),
            _c(
              "div",
              { staticClass: "show-imgs" },
              [
                _vm._l(_vm.fileList.slice(0, _vm.maxLength), function(item, i) {
                  return [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: i === _vm.viewIndex,
                          expression: "i === viewIndex"
                        }
                      ],
                      key: i,
                      style: { opacity: i === _vm.viewIndex ? 1 : 0 },
                      attrs: { src: item.url }
                    })
                  ]
                })
              ],
              2
            )
          ])
        ]
      ),
      _vm._l(_vm.fileSizes, function(size, index) {
        return _c(
          "p",
          { key: index, staticClass: "tips" },
          [
            _vm._v(" 图片" + _vm._s(index + 1) + "大小为 "),
            _c("span", [_vm._v(" " + _vm._s(size.transformSize) + " ")]),
            size.originSize >= 100000
              ? [
                  _vm._v(" ， "),
                  _c("span", { staticClass: "bold" }, [
                    _vm._v(" 已超出100KB，建议优化图片大小后重新上传 ")
                  ])
                ]
              : _vm._e()
          ],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }